"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (g && (g = 0, op[0] && (_ = 0)), _) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var ahooks_1 = require("ahooks");
var antd_1 = require("antd");
var classnames_1 = __importDefault(require("classnames"));
var react_1 = __importStar(require("react"));
var useConfig_1 = __importDefault(require("../../_util/useConfig"));
var XlsxExport_1 = require("../../_util/XlsxExport");
var Table_1 = __importDefault(require("./Table"));
function TceTable(props) {
    var _this = this;
    var _a;
    var _b = props.data, leftOptiosData = _b === void 0 ? [] : _b, paginationOpts = props.paginationOpts;
    var _c = paginationOpts || {}, _d = _c.downloadText, downloadText = _d === void 0 ? '' : _d, _e = _c.downloadTitle, downloadTitle = _e === void 0 ? '' : _e;
    var _f = (0, useConfig_1.default)(), classPrefix = _f.classPrefix, mobileWidth = _f.mobileWidth;
    var _g = (0, react_1.useState)(''), selectedItem = _g[0], setSelectedItem = _g[1];
    var _h = (0, react_1.useState)({}), tableList = _h[0], setTableList = _h[1];
    var _j = (0, react_1.useState)(''), featureDesc = _j[0], setFeatureDesc = _j[1];
    var _k = (0, react_1.useState)({ row: [], col: [] }), downloadData = _k[0], setDownloadData = _k[1];
    var _l = (0, react_1.useState)(''), selectTitle = _l[0], setSelectTitle = _l[1];
    var ref = (0, react_1.useRef)(null);
    var size = (0, ahooks_1.useSize)(ref);
    var menuItems = [];
    if (leftOptiosData && leftOptiosData.length > 0) {
        menuItems = ((_a = leftOptiosData[0]) === null || _a === void 0 ? void 0 : _a.hardwareGroupData) || [];
    }
    function handleMenuClick(id) {
        if (id === selectedItem) {
            return false;
        }
        setSelectedItem(id);
        setFeatureDesc('');
        setTableList({});
    }
    (0, react_1.useEffect)(function () {
        var _a;
        if (menuItems && menuItems.length > 0) {
            var selectProductKey_1 = selectedItem;
            if (!selectProductKey_1) {
                var defMenuItem = menuItems[0];
                selectProductKey_1 = defMenuItem.hardwareCode;
                setSelectedItem(selectProductKey_1);
            }
            var selectMenuItem = menuItems.find(function (item) { return item.hardwareCode === selectProductKey_1; });
            if (selectMenuItem) {
                var hardwareName = selectMenuItem.hardwareName, desc = selectMenuItem.desc, data = selectMenuItem.data;
                setSelectTitle(hardwareName);
                if ((_a = data === null || data === void 0 ? void 0 : data[0]) === null || _a === void 0 ? void 0 : _a.data) {
                    setTableList(data[0].data);
                }
                setFeatureDesc(desc || '');
            }
        }
    }, [leftOptiosData, selectedItem]);
    function renderPcMenu() {
        return (react_1.default.createElement("div", { className: "".concat(classPrefix, "__tceSimpleTable-left-menu") },
            react_1.default.createElement("div", { className: "".concat(classPrefix, "__tceSimpleTable-left-menu-container") }, menuItems.map(function (item, index) {
                var _a;
                var hardwareCode = item.hardwareCode, hardwareName = item.hardwareName, icon = item.icon;
                return (react_1.default.createElement("div", { key: index, className: (0, classnames_1.default)("".concat(classPrefix, "__tceSimpleTable-left-menu-container-item"), (_a = {},
                        _a["".concat(classPrefix, "__tceSimpleTable-left-menu-container-item-selected")] = hardwareCode === selectedItem,
                        _a)), onClick: function () { return handleMenuClick(hardwareCode); } },
                    icon && (react_1.default.createElement("span", { className: "".concat(classPrefix, "__tceSimpleTable-left-menu-container-item-icon") }, icon)),
                    react_1.default.createElement("span", { className: "".concat(classPrefix, "__tceSimpleTable-left-menu-container-item-label") }, hardwareName)));
            }))));
    }
    function renderMobileMenu() {
        return (react_1.default.createElement("div", { className: "".concat(classPrefix, "__tceSimpleTable-mobile-menu") },
            react_1.default.createElement(antd_1.Select, { className: "".concat(classPrefix, "__tceSimpleTable-mobile-menu-mySelect"), options: menuItems.map(function (item) {
                    return __assign(__assign({}, item), { label: item.hardwareName, value: item.hardwareCode });
                }), value: selectedItem, placeholder: '请选择产品', onChange: function (value) {
                    setSelectedItem(value);
                    setFeatureDesc('');
                    setTableList({});
                } })));
    }
    // 构造下载的数据
    function transformedData(a, b) {
        return a.map(function (item) {
            var newObj = {};
            item.data.forEach(function (dataItem) {
                var config = b.find(function (configItem) { return configItem.key === dataItem.key; });
                if (config) {
                    var excelText = dataItem.text.replace(/<br\s*\/?>/gi, '\r\n'); // 将br换为excel支持的换行符
                    newObj[config.text] = excelText;
                }
            });
            return newObj; // 直接返回新对象，去掉 data 层
        });
    }
    // 下载excel
    var handleDownloadClick = function () { return __awaiter(_this, void 0, void 0, function () {
        var row, col, result, title;
        var _a;
        return __generator(this, function (_b) {
            switch (_b.label) {
                case 0:
                    if (!(((_a = downloadData === null || downloadData === void 0 ? void 0 : downloadData.row) === null || _a === void 0 ? void 0 : _a.length) > 0)) return [3 /*break*/, 2];
                    row = downloadData.row, col = downloadData.col;
                    result = transformedData(row, col);
                    title = '';
                    if (downloadTitle) {
                        title = downloadTitle.concat('-', selectTitle);
                    }
                    else {
                        title = selectTitle;
                    }
                    return [4 /*yield*/, (0, XlsxExport_1.exportWithWrapText)(result, title)];
                case 1:
                    _b.sent();
                    _b.label = 2;
                case 2: return [2 /*return*/];
            }
        });
    }); };
    return (react_1.default.createElement("div", { ref: ref, className: "".concat(classPrefix, "__tceSimpleTable") },
        Number(size === null || size === void 0 ? void 0 : size.width) <= mobileWidth ? renderMobileMenu() : renderPcMenu(),
        react_1.default.createElement("div", { className: "".concat(classPrefix, "__tceSimpleTable-right-content") },
            react_1.default.createElement(antd_1.Button, { className: "".concat(classPrefix, "__tceSimpleTable-right-content-btn"), onClick: function () { return void handleDownloadClick(); } }, downloadText || 'Download'),
            react_1.default.createElement(Table_1.default, { data: tableList, paginationOpts: paginationOpts, dataFilterCallback: function (row, col) {
                    setDownloadData({ row: row, col: col });
                } }),
            featureDesc && (react_1.default.createElement("div", { className: "".concat(classPrefix, "__tceSimpleTable-right-tab-desc") }, featureDesc)))));
}
exports.default = TceTable;
//# sourceMappingURL=TceTable.js.map